import {Component, ComponentFactoryResolver, ComponentRef, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Observable} from 'rxjs/Observable';
import {ModalSimpleComponent} from '../model-simple/modal-simple.component';
import {DialogAdapter, DialogParams, DialogResult} from '../../models/dialog-param';
import {Subject} from 'rxjs/Subject';
import {SharedValueService} from '../../services/shared-value.service';
import {ModalEventComponent} from '../modal-event/modal-event.component';
import {BUTTON_NAME, EVENT_RECURSIVE_OPTIONS} from '../../common/constants';
import {ModalActionButtonsComponent} from '../modal-action-buttons/modal-action-buttons.component';
import {ModalUserComponent} from '../modal-user/modal-user.component';
import {ModalChangePasswordComponent} from '../modal-change-password/modal-change-password.component';
import {ModalProfileComponent} from '../modal-profile/modal-profile.component';
import {ModalCropperComponent} from '../modal-cropper/modal-cropper.component';
import {ModalRoomGroupComponent} from '../modal-room-group/modal-room-group.component';
import {Subscription} from 'rxjs/Rx';
import {Helper} from '../../common/helper';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  preserveWhitespaces: false,
  entryComponents: [
    ModalSimpleComponent,
    ModalEventComponent,
    ModalActionButtonsComponent,
    ModalRoomGroupComponent,
    ModalUserComponent,
    ModalChangePasswordComponent,
    ModalProfileComponent,
    ModalCropperComponent
  ]
})
export class ModalComponent implements OnDestroy {
  public dialog = new DialogParams(ModalSimpleComponent, null, null,
    null, null, null, null, null, null, new Subject(), {}, null);

  @ViewChild('theBody', {read: ViewContainerRef}) theBody: ViewContainerRef;

  cmpRef: ComponentRef<DialogAdapter>;
  html: any;
  isLoading = false;
  subscription: Subscription;

  constructor(sharedService: SharedValueService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private sanitizer: DomSanitizer,
              private helper: Helper) {

    sharedService.showModal.subscribe(dialog => {
      this.dialog = dialog;
      if (this.cmpRef) {
        this.cmpRef.destroy();
      }
      this.isLoading = false;
      const factory = this.componentFactoryResolver.resolveComponentFactory(dialog.componentType);
      this.cmpRef = this.theBody.createComponent(factory);
      this.cmpRef.instance.params = dialog;
      this.cmpRef.instance.onModalInit();

      this.html = this.sanitizer.bypassSecurityTrustHtml(this.dialog.html);

      (<any>$('#theModal')).modal('show');
    });
    this.helper._unsubsribe(this.subscription);
    this.subscription = sharedService.getWaitingApiResponse().subscribe(res => {
      this.isLoading = res;
    });
  }

  close() {
    if (this.cmpRef) {
      this.cmpRef.destroy();
    }
    this.cmpRef = null;
    this.dialog = new DialogParams(ModalSimpleComponent, null, null, null,
      null, null, null, null, null, new Subject(), {}, null);
    (<any>$('#theModal')).modal('hide');
  }

  onClickPositive() {
    if (this.isLoading) {
      return;
    }
    const object = this.cmpRef.instance.getPayload();
    if (object instanceof Observable) {
      object.subscribe(result => {
        this.handleEventClickPositiveBtn(result);
      });
    } else {
      this.handleEventClickPositiveBtn(object);
    }
  }

  handleEventClickPositiveBtn(object: any) {
    if (object) {
      if (object.isAPICallError || object.checkValidate || object.isCropperImage ||
        (object.hasOwnProperty('recursive_option') && !Object.values(EVENT_RECURSIVE_OPTIONS).includes(object.recursive_option))) {
        this.cmpRef.instance.params = this.dialog;
        this.cmpRef.instance.onModalInit();
      } else {
        this.dialog.subject.next(new DialogResult(BUTTON_NAME.OK, this.cmpRef.instance.getPayload()));
        this.dialog.subject.complete();
        this.close();
      }
    } else {
      this.dialog.subject.next(new DialogResult(BUTTON_NAME.OK, this.cmpRef.instance.getPayload()));
      this.dialog.subject.complete();
      this.close();
    }
  }

  deleteEvent() {
    this.dialog.subject.next(new DialogResult(BUTTON_NAME.DELETE, this.cmpRef.instance.getPayload()));
    this.dialog.subject.complete();
  }

  checkInEvent() {
    this.dialog.subject.next(new DialogResult(BUTTON_NAME.CHECK_IN, this.cmpRef.instance.getPayload()));
    this.dialog.subject.complete();
    this.close();
  }

  onClickNegative() {
    this.dialog.subject.next(new DialogResult(BUTTON_NAME.CANCEL, null));
    this.dialog.subject.complete();
    this.close();
  }

  ngOnDestroy() {
    this.helper._unsubsribe(this.subscription);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/modal/modal.component.ts